export enum ComplexShortcutsEnum {
  NOW = 'now',
  CURRENT_TIME = 'ref0',
  CURRENT_DATE = 'ref1',
  START_OF_TODAY = 'ref2',
  END_OF_TODAY = 'ref3',
  LAST_MONDAY = 'ref4',
  BEGINNING_OF_MONTH = 'ref5',
  BEGINNING_OF_YEAR = 'ref6',
  CURRENT_YEAR = 'ref7',
}
